import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "context/Authentication";
import FullWidthBanner from "./FullWidthBanner.jsx";
import StandardBanner from "./StandardBanner.jsx";
import CompactBanner from "./CompactBanner.jsx";
import ContainedBanner from "./ContainedBanner.jsx";

export default function PageBannerRenderer({ banners }) {
  const navigate = useNavigate();
  const context = useContext(AuthContext);

  // Helper function to handle CTA button navigation
  const handleCTANavigation = (ctaLink) => {
    if (!ctaLink) return;

    try {
      // Check if it's an external URL
      if (ctaLink.startsWith("http://") || ctaLink.startsWith("https://")) {
        window.open(ctaLink, "_blank");
      } else if (ctaLink.startsWith("/")) {
        // Internal route
        navigate(ctaLink);
      } else {
        // Relative route
        navigate(`/${ctaLink}`);
      }
    } catch (error) {
      console.error("Navigation error:", error);
    }
  };

  // Group banners by Banner_Code for slider functionality
  const groupBannersByCode = (bannerList) => {
    const grouped = {};
    bannerList.forEach((banner) => {
      const code = banner.Banner_Code || `default_${banner.Banner_ID}`;
      if (!grouped[code]) {
        grouped[code] = [];
      }
      grouped[code].push(banner);
    });
    return grouped;
  };

  // Separate banners by type
  const fullWidthBanners = banners.filter(
    (b) => b.Banner_Type === "Hero Banner - Full width"
  );
  const standardBanners = banners.filter(
    (b) => b.Banner_Type === "Hero Banner"
  );
  const compactBanners = banners.filter(
    (b) => b.Banner_Type === "Compact Hero Banner"
  );
  const containedBanners = banners.filter(
    (b) => b.Banner_Type === "Contained Banner"
  );

  // Group each type by Banner_Code
  const fullWidthGroups = groupBannersByCode(fullWidthBanners);
  const standardGroups = groupBannersByCode(standardBanners);
  const compactGroups = groupBannersByCode(compactBanners);
  const containedGroups = groupBannersByCode(containedBanners);

  return (
    <React.Fragment>
      {/* Full Width Banners */}
      {fullWidthBanners.length > 0 && (
        <FullWidthBanner
          key="fullwidth_banners"
          banners={fullWidthBanners}
          handleCTANavigation={handleCTANavigation}
        />
      )}

      {/* Standard Hero Banners */}
      {standardBanners.length > 0 && (
        <StandardBanner
          key="standard_banners"
          banners={standardBanners}
          handleCTANavigation={handleCTANavigation}
        />
      )}

      {/* Compact Hero Banners */}
      {compactBanners.length > 0 && (
        <CompactBanner
          key="compact_banners"
          banners={compactBanners}
          handleCTANavigation={handleCTANavigation}
        />
      )}

      {/* Contained Banners */}
      {containedBanners.length > 0 && (
        <ContainedBanner
          key="contained_banners"
          banners={containedBanners}
          handleCTANavigation={handleCTANavigation}
        />
      )}
    </React.Fragment>
  );
}
